/** Display name for the application. All UI headings and metadata must use this constant. */
export const APP_NAME = 'Vintage Modeling' as const;
